const toSlug = require('@converdy/utils/to-slug')

export default function toValidFunnelSlug (rawSlug, usedSlugs = []) {
  /*
   * This regex matches any characters except for:
   * - alphanumeric
   * - hyphens
   * - underscores
   */ 

  rawSlug = typeof rawSlug === 'string' ? rawSlug.trim() : ""
  return toSlug(rawSlug).replace(/[^a-zA-Z0-9\-\_]+/g, '')
}
